import enumConstants from './../enumConstants.json'
import { MODEL_TYPE } from './model_types.jsx'

export const JOURNAL_LINES_ENTRY_HEADER_TYPE_TO_MODEL_TYPE = {
  [enumConstants.journal_line_entry_header_types.SALES_INVOICE]: MODEL_TYPE.SALES_INVOICE,
  [enumConstants.journal_line_entry_header_types.SALES_CREDIT_MEMO]: MODEL_TYPE.SALES_CREDIT_MEMO,
  [enumConstants.journal_line_entry_header_types.SALES_FINANCE_CHARGE]: MODEL_TYPE.SALES_FINANCE_CHARGE,
  [enumConstants.journal_line_entry_header_types.SALES_ADVANCE_INVOICE]: MODEL_TYPE.SALES_ADVANCE_INVOICE,
  [enumConstants.journal_line_entry_header_types.PURCHASE_INVOICE]: MODEL_TYPE.PURCHASE_INVOICE,
  [enumConstants.journal_line_entry_header_types.PURCHASE_CREDIT_MEMO]: MODEL_TYPE.PURCHASE_CREDIT_MEMO,
  [enumConstants.journal_line_entry_header_types.PURCHASE_FINANCE_CHARGE]: MODEL_TYPE.PURCHASE_FINANCE_CHARGE,
  [enumConstants.journal_line_entry_header_types.PURCHASE_ADVANCE_INVOICE]: MODEL_TYPE.PURCHASE_ADVANCE_INVOICE,
  [enumConstants.journal_line_entry_header_types.BANK_STATEMENT]: MODEL_TYPE.BANK_STATEMENT,
  [enumConstants.journal_line_entry_header_types.TRANSFER_ORDER_SHIPMENT]: MODEL_TYPE.TRANSFER_ORDER,
  [enumConstants.journal_line_entry_header_types.TRANSFER_ORDER_RECEIPT]: MODEL_TYPE.TRANSFER_ORDER,
  [enumConstants.journal_line_entry_header_types.PHYSICAL_INVENTORY]: MODEL_TYPE.PHYSICAL_INVENTORY,
  [enumConstants.journal_line_entry_header_types.RECLASSIFICATION_ORDER]: MODEL_TYPE.RECLASSIFICATION_ORDER,
  [enumConstants.journal_line_entry_header_types.SALARY_CALCULATION]: MODEL_TYPE.SALARY_CALCULATION,
  [enumConstants.journal_line_entry_header_types.PERSON_PAYMENT]: MODEL_TYPE.PERSON_PAYMENT
}
